export const maxValue = (g, r, u, t) => Math.max(
  ...g.map(x => x.additions + x.deletions),
  ...r.map(x => x.y),
  ...u.map(x => x.y),
  ...t.map(x => x.y),
  10
)